import React from 'react';
import { Trans } from '@lingui/react/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSwatchbook } from '@fortawesome/pro-light-svg-icons';

import theme from '../components/RoomOptionTwoTierList/RoomOptionTwoTierList.module.scss';
import local from './RoomStyleSection.module.scss';
import { StyleGroupRow } from './StyleGroupRow';
import { StyleSelectionModal } from './StyleSelectionModal';
import { useStyleWalkthrough } from './useStyleWalkthrough';

/**
 * The room's Styles section, rendered at the top of the immersive/showroom option-group list
 * (`GroupList`). Shows a "Styles" separator (styled like the deadline separators) and one row per
 * applicable style group — the room's own groups plus any global group with options in this room.
 * Clicking a row opens the style-selection modal. Renders nothing when no style group applies.
 *
 * Returns a fragment of `<li>` so it can drop straight into `GroupList`'s `<ul>`.
 */
export const RoomStyleSection: React.FC = () => {
    const { groups, walkGroups, openGroup, close } = useStyleWalkthrough();

    if (groups.length === 0) {
        return null;
    }

    return (
        <>
            <li className={theme.deadlineSeparator}>
                <span className={theme.separatorLabel}>
                    <FontAwesomeIcon className={theme.separatorIcon} icon={faSwatchbook} />
                    <span className={theme.deadlineName}>
                        <Trans>Styles</Trans>
                    </span>
                </span>
            </li>
            {groups.map((group) => (
                <li key={`style-${group.id}`}>
                    <StyleGroupRow styleGroup={group} onClick={() => openGroup(group)} />
                </li>
            ))}
            {/* display: contents so this list item never affects layout — the modal portals to <body>. */}
            <li className={local.modalHost}>
                {walkGroups && walkGroups.length > 0 && <StyleSelectionModal groups={walkGroups} onClose={close} />}
            </li>
        </>
    );
};
